import ApiService from "../../utils/fetch";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchOutboundOrders = async ({
  page = 0,
  size = 10,
  sort = [],
  filters = {},
}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);

  if (sort && Array.isArray(sort)) {
    sort.forEach((s) => params.append("sort", s));
  }

  const response = await ApiService.post(
    `${BASE_URL}demand/orders?${params}`,
    {
      ...filters,
    }
  );

  const res = response.data;

  return {
    rows: res.content,
    totalPages: res.totalPages,
    totalElements: res.totalElements,
  };
};

/**
 * Fetch distinct filter options for a specific column
 * @param {string} column - Column name
 * @param {object} filters - Currently applied filters for cascading behavior
 * @returns {Promise<string[]>} Array of distinct values for the column
 */
export const fetchFilterOptions = async (column, filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('column', column);

    // Build ColumnFilterRequest body for demand/orders
    const requestBody = {
      columnFilters: filters?.columnFilters || {},
    };
    if (filters?.states) requestBody.states = filters.states;
    if (filters?.exceptions) requestBody.exceptions = filters.exceptions;

    const response = await ApiService.post(
      `${BASE_URL}demand/orders/filter-options?${params}`,
      requestBody
    );
    return response.data.values || [];
  } catch (error) {
    console.error(`Error fetching filter options for ${column}:`, error);
    return [];
  }
};
